// Disabling react/no-danger to be able to use "dangerouslySetInnerHTML" to include
// links in the middle of localized texts.
/* eslint-disable react/no-danger */

import React from 'react';
import PropTypes from 'prop-types';

const getAttributeValue = (tag, attribute) => {
  const escapedAttribute = attribute.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const match = tag.match(new RegExp(`${escapedAttribute}="([^"]*)"`));

  return match?.[1];
};

const divHTMLRender = ({
  text,
  className,
  tagReplaceStart,
  tagReplaceEnd,
  icon,
  'data-testid': dataTestid,
}) => {
  if (tagReplaceStart && tagReplaceEnd && icon) {
    const [beforeLink, rest = ''] = text.split('{{tagReplaceStart}}');
    const [linkText, afterLink = ''] = rest.split('{{tagReplaceEnd}}');

    const href = getAttributeValue(tagReplaceStart, 'href');
    const target = getAttributeValue(tagReplaceStart, 'target');
    const rel = getAttributeValue(tagReplaceStart, 'rel');
    const linkDataTestId = getAttributeValue(tagReplaceStart, 'data-testid');

    return (
      <div
        className={className}
        data-testid={dataTestid}
      >
        {beforeLink}
        <a
          data-testid={linkDataTestId}
          href={href}
          target={target}
          rel={rel}
        >
          {linkText}
          {icon}
        </a>
        {afterLink}
      </div>
    );
  }

  let textParsed = text;
  if (tagReplaceStart && tagReplaceEnd) {
    textParsed = text
      .replaceAll('{{tagReplaceStart}}', tagReplaceStart)
      .replaceAll('{{tagReplaceEnd}}', tagReplaceEnd);
  }

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: textParsed }}
      data-testid={dataTestid}
    />
  );
};

divHTMLRender.defaultProps = {
  tagReplaceStart: null,
  tagReplaceEnd: null,
  icon: null,
  'data-testid': null,
};

divHTMLRender.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  tagReplaceStart: PropTypes.string,
  tagReplaceEnd: PropTypes.string,
  icon: PropTypes.node,
  dataTestid: PropTypes.string,
};

export default divHTMLRender;
